module.exports = __webpack_public_path__ + "static/media/zahira.86513a33.jpeg";